
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zM7 8v16.457h18.286v-12.8H19.8V8H7zm3.657 3.657h1.829v1.829h-1.829v-1.829zm3.657 0h1.829v1.829h-1.829v-1.829zm5.486 1.829h3.657v9.143H19.8V20.8h1.829v-1.829H19.8v-1.828h1.829v-1.829H19.8v-1.828zm-9.143 1.828h1.829v1.829h-1.829v-1.829zm3.657 0h1.829v1.829h-1.829v-1.829zm-3.657 3.657h1.829V20.8h-1.829v-1.829zm3.657 0h1.829V20.8h-1.829v-1.829z"}})])
          )
        }
      }
    